<form #DetailForm="ngForm">
  <div class="container position-absolute top-0 start-0" >
    <div class="row">
      <div class="col-xl-12">Falls Sie Interesse haben und mit mir Kontakt aufnehmen wollen, senden Sie mir einfach eine Nachricht.</div>
    </div>
    <div class="row">
      <div class="col-xl-2">Name</div>
      <div class="col-xl-6">
        <input class="form-control" name="Name" type="text" [(ngModel)]="model.cont.cont_name" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-2">Stadt</div>
      <div class="col-xl-6">
        <input class="form-control" name="Stadt" type="text" [(ngModel)]="model.cont.cont_stadt" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-2">Telefon</div>
      <div class="col-xl-6">
        <input class="form-control" name="Telefon" type="text" [(ngModel)]="model.cont.cont_telefon" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-2">Handy</div>
      <div class="col-xl-6">
        <input class="form-control" name="Handy" type="text" [(ngModel)]="model.cont.cont_handy" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-2">Email</div>
      <div class="col-xl-6">
        <input class="form-control" #Email="ngModel" required name="Email" type="email" [(ngModel)]="model.cont.cont_email" placeholder="Email address" />
      </div>
      <div class="col-xl-2" [hidden]="Email.valid">Please enter a email.</div>
    </div>
    <div class="row">
      <div class="col-xl-2">Nachricht</div>
      <div class="col-xl-6">
        <textarea class="form-control" rows="3" name="Nachricht" [(ngModel)]="model.cont.cont_nachricht"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div><button class="btn btn-primary" [disabled]="!DetailForm.form.valid || !model.enabled"  (click)="DetailForm.form.valid && addCONT()" type="button">Senden</button></div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        {{ model.text }}
      </div>
    </div>
  </div>
</form>
